<template>
    <div>
        <div class="tvgeemel_asuult">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="title">ТҮГЭЭМЭЛ АСУУЛТ ХАРИУЛТ</h3>
                </div>
<!--                <div class="col-md-8">-->
<!--                    <h3 class="title">ТҮГЭЭМЭЛ АСУУЛТ ХАРИУЛТ</h3>-->
<!--                </div>-->
<!--                <div class="col-md-4">-->
<!--                    <div>-->
<!--                        <Select v-model="selected" style="width: 100%">-->
<!--                            <Option v-for="item in answers" :value="item.id" :key="item.id">{{ item.cat_title }}</Option>-->
<!--                        </Select>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="tvgeemel_asuult_item">
                        <p>Суралцагч</p>
                        <br>
                        <div class="scroll">
                            <Collapse accordion>
                                <Panel :key="index" v-for="(answer, index) in answers1" >
                                    {{answer.asuult}}
                                    <p slot="content">{{answer.hariult}}</p>
                                </Panel>
                            </Collapse>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="tvgeemel_asuult_item">
                        <p>Сургалтын байгууллага</p>
                        <br>
                        <div class="scroll">
                            <Collapse accordion>
                                <Panel  :key="index" v-for="(answer, index) in answers2" >
                                    {{answer.asuult}}
                                    <p slot="content">{{answer.hariult}}</p>
                                </Panel>
                                <!--                            <Panel name="2">-->
                                <!--                                Хуурамч текстийн зай одоо ч харагдах харанхуй.-->
                                <!--                                <p slot="content">Хуурамч текстийн зай одоо ч харагдах харанхуй.</p>-->
                                <!--                            </Panel>-->
                                <!--                            <Panel name="3">-->
                                <!--                                Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.-->
                                <!--                                <p slot="content">Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                <!--                            </Panel>-->
                            </Collapse>
                        </div>

                    </div>
                </div>
            </div>
<!--            <div class="row">-->
<!--                <div class="col-md-12">-->
<!--                    <div class="tvgeemel_asuult_item">-->
<!--                        <Collapse accordion>-->
<!--                            <Panel  :key="index" v-for="(answer, index) in answers" >-->
<!--                                {{answer.asuult}}-->
<!--                                <p slot="content">{{answer.hariult}}</p>-->
<!--                            </Panel>-->
<!--                        </Collapse>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>
<script>
    export default {
        name: 'home',

        data () {
            return {
                value1: '1',
                value2: '2',
                suraltsagch: [],
                sbaiguullaga: [],
                answers: [],
                answers1: [],
                answers2: [],
                cityList: [
                    {
                        value: 'sur',
                        label: 'Сургалтын байгууллага'
                    },
                    {
                        value: 'sur1',
                        label: 'Суралцагч'
                    },
                ],
                selected: 1,
            }
        },
        methods: {

        },
        mounted () {
            this.answers = window.init.faq;
            this.answers1 = window.init.faq[0].asuults;
            this.answers2 = window.init.faq[1].asuults;
            //console.log(this.answers);



        },
    }
</script>
